(() => {
  // Filter the existing bundle lineup without changing its purchase destinations.
  const bundleButtons = [...document.querySelectorAll('[data-bundle-filter]')];
  const bundles = [...document.querySelectorAll('[data-bundle-category]')];
  bundleButtons.forEach(button => button.addEventListener('click', () => {
    const category = button.dataset.bundleFilter;
    bundleButtons.forEach(item => {
      const active = item === button;
      item.classList.toggle('active', active);
      item.setAttribute('aria-pressed', String(active));
    });
    bundles.forEach(card => { card.hidden = category !== 'all' && card.dataset.bundleCategory !== category; });
    const count = bundles.filter(card => !card.hidden).length;
    document.querySelector('[data-bundle-count]').textContent = `${count} ${count === 1 ? 'bundle' : 'bundles'}`;
  }));
  const search = document.querySelector('[data-blog-search]');
  if (search) {
    const buttons = [...document.querySelectorAll('[data-filter]')];
    const cards = [...document.querySelectorAll('.article-grid [data-article]')];
    const clear = document.querySelector('[data-clear-guides]');
    const empty = document.querySelector('[data-guide-empty]');
    let category = 'all';
    function render() {
      const query = search.value.trim().toLocaleLowerCase();
      cards.forEach(card => {
        const categoryMatch = category === 'all' || card.dataset.category.split(' ').includes(category);
        card.hidden = !categoryMatch || !card.textContent.toLocaleLowerCase().includes(query);
      });
      const count = cards.filter(card => !card.hidden).length;
      document.querySelector('[data-guide-count]').textContent = `${count} ${count === 1 ? 'guide' : 'guides'}${query || category !== 'all' ? ' found' : ' to explore'}`;
      empty.hidden = count > 0;
      clear.hidden = !query && category === 'all';
      buttons.forEach(button => {
        const active = button.dataset.filter === category;
        button.classList.toggle('active', active);
        button.setAttribute('aria-pressed', String(active));
      });
    }
    function revealResults() {
      document.querySelector('#guide-library').scrollIntoView({behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start'});
    }
    buttons.forEach(button => button.addEventListener('click', () => { category = button.dataset.filter; render(); revealResults(); }));
    search.addEventListener('input', render);
    document.querySelector('[data-guide-search-form]').addEventListener('submit', event => { event.preventDefault(); render(); revealResults(); });
    document.querySelectorAll('[data-clear-guides],[data-reset-guides]').forEach(button => button.addEventListener('click', () => { category = 'all'; search.value = ''; render(); }));
    render();
  }
})();
